"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CampaignSortFieldToJSON = exports.CampaignSortFieldFromJSONTyped = exports.CampaignSortFieldFromJSON = exports.CampaignSortField = void 0;
/**
 * Field by which to sort campaigns.
 * @export
 */
exports.CampaignSortField = {
    Id: 'ID',
    Name: 'NAME',
    CreatedAt: 'CREATED_AT',
    UpdatedAt: 'UPDATED_AT',
    Status: 'STATUS'
};
function CampaignSortFieldFromJSON(json) {
    return CampaignSortFieldFromJSONTyped(json, false);
}
exports.CampaignSortFieldFromJSON = CampaignSortFieldFromJSON;
function CampaignSortFieldFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.CampaignSortFieldFromJSONTyped = CampaignSortFieldFromJSONTyped;
function CampaignSortFieldToJSON(value) {
    return value;
}
exports.CampaignSortFieldToJSON = CampaignSortFieldToJSON;
